export default "<div>\r\n  <div class=\"visualization\" #visElement></div>\r\n</div>\r\n"